import { ViewportScroller } from "@angular/common";
import { Injectable, OnDestroy } from "@angular/core";
import { ActivatedRoute, GuardsCheckEnd, NavigationStart, Router } from "@angular/router";
import { Subject, Subscription } from "rxjs";
import { filter, last } from 'rxjs/operators';

@Injectable()
export class LayoutService implements OnDestroy {
    private headingSource = new Subject<string>();
    onHeadingChange = this.headingSource.asObservable();
    private closeSource = new Subject();
    onClose = this.closeSource.asObservable();
    private sidenavToggleSource = new Subject<boolean>();
    onSidenavToggle = this.sidenavToggleSource.asObservable();
    private routerSubscription: Subscription;
    private backUrl: string[];
    private backRoute: ActivatedRoute;
    private routeState: any;
    private scrollPosition: [number, number];
    private scrollTo: [number, number];
    private lastUrl: string = window.location.pathname;

    constructor(private router: Router, private scroller: ViewportScroller) {       
        this.routerSubscription = this.router.events
            .pipe(
                filter(event => event instanceof NavigationStart || event instanceof GuardsCheckEnd),
            )
            .subscribe(event => {
                if (event instanceof NavigationStart) {
                    if (!!this.scrollPosition) {
                        this.scrollTo = this.scrollPosition;
                    }
                    this.scrollPosition = [window.scrollX, window.scrollY];
                    this.routeState = this.router.getCurrentNavigation().extras.state;
                }
                else {
                    if ((<GuardsCheckEnd>event).shouldActivate) {
                        const url = (<GuardsCheckEnd>event).urlAfterRedirects.split(/\#|\?/)[0].toLowerCase();
                        //If all guards let us complete navigation and we are NOT navigating on the same page, restore some properties and unsubscribe
                        if (this.lastUrl !== url) {
                            this.backUrl = null;
                            this.backRoute = null;
                            this.closeSource.observers.every(x => x.complete());
                        }
                        this.lastUrl = url;
                    }
                }
            });
    }

    ngOnDestroy() {
        this.routerSubscription.unsubscribe();
    }

    setHeading(value: string) : LayoutService {
        if (value) {
            Promise.resolve().then(() => { //Not sure why this is needed but causes ExpressionChangedAfterItHasBeenCheckedError without it
                this.headingSource.next(value);
            });
        }
        return this;
    }
    
    getBackUrl(): string[] {
        return this.backUrl;
    }

    setBackUrl(url: string[], route: ActivatedRoute) : LayoutService {
        this.backUrl = url;
        this.backRoute = route;
        return this;
    }

    close(useFragment: boolean = true) {        
        if (!!this.backUrl) {
            let fragment = !!this.routeState && useFragment ? this.routeState.fragment : null;
            this.router.navigate(this.backUrl, { relativeTo: this.backRoute, fragment: fragment, state: { scrollRestore: true } });
        }
        else {
            this.closeSource.next(null);
        }
    }

    scrollRestore() {
        if (!!this.routeState && this.routeState.scrollRestore && !!this.scrollTo) {
            this.scroller.scrollToPosition(this.scrollTo);
        }
        else {
            this.scroller.scrollToPosition([0, 0]);
        }
    }

    sidenavOpened() {
        this.sidenavToggleSource.next(true);
    }

    sidenavClosed() {
        setTimeout(() => this.sidenavToggleSource.next(false), 400);
    }
}